var _path, _path2, _path3, _mask, _g, _mask2, _g2, _path4, _path5, _mask3, _g3, _mask4, _g4, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 13,
    viewBox: "0 0 89 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.15 1.658c0 .863-.69 1.561-1.542 1.561a1.552 1.552 0 01-1.543-1.56c0-.863.69-1.562 1.543-1.562.851 0 1.542.7 1.542 1.561z",
    fill: "#C361E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.928 12.792c-.894 0-1.543-.694-1.543-1.65V1.747c0-.956.649-1.65 1.543-1.65.893 0 1.542.694 1.542 1.65v9.393c0 .957-.649 1.651-1.542 1.651zM64.29 12.792c-.895 0-1.544-.694-1.544-1.65V1.747c0-.956.65-1.65 1.543-1.65.894 0 1.543.694 1.543 1.65v9.393c0 .957-.65 1.651-1.543 1.651zM81.158 12.792c-.894 0-1.543-.694-1.543-1.65V1.747c0-.956.65-1.65 1.543-1.65.894 0 1.543.694 1.543 1.65v9.393c0 .957-.648 1.651-1.543 1.651zM28.46.097l-4.255.015c-.87 0-1.575.711-1.575 1.588 0 .876.705 1.587 1.575 1.587h2.68v7.856c0 .598.258 1.093.675 1.38.25.172.558.27.9.27.342 0 .65-.098.9-.27.417-.287.676-.782.676-1.38V1.747c0-.956-.663-1.65-1.576-1.65z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.818 11.231c0 .862-.691 1.56-1.543 1.56a1.552 1.552 0 01-1.543-1.56c0-.862.69-1.56 1.543-1.56.852 0 1.543.698 1.543 1.56z",
    fill: "#0B72CE"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 0,
    width: 8,
    height: 4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.056 0H89v3.189h-7.944V0z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.359 0h-6.303v3.189h6.303c.95 0 1.64-.67 1.64-1.594S88.31 0 87.36 0z",
    fill: "#fff"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 9,
    width: 8,
    height: 4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.056 9.583H89v3.19h-7.944v-3.19z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.359 9.583h-6.303v3.19h6.303c.95 0 1.64-.671 1.64-1.595 0-.924-.69-1.595-1.64-1.595z",
    fill: "#fff"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.433 6.444c0 .863-.69 1.561-1.543 1.561a1.552 1.552 0 01-1.543-1.56c0-.863.691-1.561 1.543-1.561s1.543.698 1.543 1.56z",
    fill: "#3BABA1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.405 8.677c1.295-.848 2.182-2.195 2.182-3.805 0-2.766-2.05-4.775-4.874-4.775h-3.947V.11h-.73v.013c-.903 0-1.558.693-1.558 1.648v9.374c0 .955.655 1.647 1.558 1.647s1.558-.692 1.558-1.647V3.286h3.283c.938 0 1.62.667 1.62 1.586 0 1.576-1.269 1.573-1.978 1.573l-.014.005a1.515 1.515 0 00-1.055.49c-.627.66-.593 1.621.081 2.285l.385.39v.004h.003l2.597 2.634c.651.687 1.596.721 2.245.083.65-.639.648-1.6-.004-2.287l-1.352-1.372z",
    fill: "#fff"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 13
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 .137h12.3v12.705H0V.137z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.105 10.472l-4.512-9.4C7.305.488 6.797.162 6.246.14 6.214.137 6.182.137 6.15.137s-.064 0-.097.003c-.55.022-1.058.348-1.347.932l-4.51 9.4c-.423.855-.143 1.776.666 2.19.809.414 1.702.093 2.124-.762L6.15 5.308 9.314 11.9c.422.855 1.315 1.176 2.124.762.808-.414 1.089-1.335.667-2.19z",
    fill: "#fff"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "d",
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 11,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.047.134h10.191v12.867H12.047V.134z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.235 10.849a1.392 1.392 0 00-1.902-1.21l-.003-.005c-.458.197-1.03.432-1.573.478a3.498 3.498 0 01-3.774-3.203 3.506 3.506 0 013.185-3.796c.6-.05 1.268.026 1.784.254v-.002c.184.064.383.095.59.077.78-.066 1.348-.756 1.294-1.542a1.39 1.39 0 00-.802-1.172l.002-.006c-.89-.45-2.058-.658-3.13-.567-3.521.3-6.134 3.413-5.836 6.954.298 3.54 3.394 6.168 6.915 5.868a6.316 6.316 0 002.365-.686l-.002-.004a1.44 1.44 0 00.887-1.438z",
    fill: "#fff"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.191 11.231c0 .862-.69 1.56-1.542 1.56a1.552 1.552 0 01-1.544-1.56c0-.862.691-1.56 1.544-1.56.851 0 1.542.698 1.542 1.56z",
    fill: "#FFBF00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.521 10.425l-4.527-9.393c-.29-.583-.8-.91-1.352-.932-.032-.003-.064-.002-.097-.003-.032.001-.064 0-.096.003-.552.023-1.063.349-1.352.932l-4.527 9.393c-.424.854-.142 1.774.669 2.188.812.413 1.708.093 2.132-.761l3.174-6.587 3.175 6.587c.424.854 1.32 1.174 2.132.76.812-.413 1.093-1.333.67-2.187zM39.695 2.465l4.527 9.393c.29.583.8.91 1.352.932.032.002.064.002.097.002.032 0 .064 0 .097-.002.551-.023 1.062-.35 1.351-.932l4.527-9.393c.424-.854.143-1.775-.669-2.188-.811-.413-1.707-.093-2.131.76L45.67 7.626l-3.175-6.587c-.424-.854-1.32-1.174-2.132-.761-.811.413-1.093 1.334-.669 2.188z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColored);
export default __webpack_public_path__ + "static/media/logo-colored.e9a643cf.svg";
export { ForwardRef as ReactComponent };